export const dateFormat = 'd.m.Y';
export const userDateFormat = 'DD/MM/YYYY - HH:mm:ss';
